import { render } from "./ViewContact.vue?vue&type=template&id=17bf5754&ts=true"
import script from "./ViewContact.vue?vue&type=script&lang=ts"
export * from "./ViewContact.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__